<!--end::Header Logo-->
<div class="d-flex align-items-stretch me-3 menu-header">
    <!--begin::Header Logo-->
    <div class="header-logo">
        <a href="javascript:void(0)" style="margin-left: 25px; margin-right: 25px">
            <img alt="Logo" src="../../../../../assets/media/logos/{{ IA }}" class="logo-sticky max-h-60px" style="height: 60px; margin-left: 10px" />
        </a>
    </div>

    <ng-container class="mobile_menu">
        <button class="btn p-0 burger-icon burger-icon-left ms-4" id="kt_header_mobile_toggle">
            <span></span>
        </button>
    </ng-container>

    <ng-container>
        <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
            <ng-container>
                <div #ktHeaderMenu id="kt_header_menu" class="header-menu header-menu-left header-menu-mobile">
                    <ul class="menu-nav" [ngClass]="ulCSSClasses">
                        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="/home" [routerLinkActive]="['active']">
                                <span class="menu-text"><i class="fas fa-home"></i>{{ 'SETTING_PAGE.HEADER.MANU_LINKS.HOME' | transloco }}</span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>

                        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="/settings/profile" [routerLinkActive]="['active']">
                                <span class="menu-text">{{ 'SETTING_PAGE.HEADER.MANU_LINKS.PROFILE' | transloco }}</span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>

                        <li *ngIf="isIdmsSettingsEnabled && curInstanceId" class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="/settings/idms" [routerLinkActive]="['active']">
                                <span class="menu-text">{{ 'SETTING_PAGE.HEADER.MANU_LINKS.IDMS' | transloco }}</span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>

                        <li *ngIf="isInformateSettingsEnabled && curInstanceId" class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="/settings/informate" [routerLinkActive]="['active']">
                                <span class="menu-text">{{ 'SETTING_PAGE.HEADER.MANU_LINKS.INFORMATE' | transloco }}</span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>

                        <li *ngIf="isCDMSSettingsEnabled" class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="/settings/cdms-settings" [routerLinkActive]="['active']">
                                <span class="menu-text">{{ 'SETTING_PAGE.HEADER.MANU_LINKS.COMPETENCY_ASSURED' | transloco }}</span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>
                        <!-- begin::1 Level -->
                        <li *ngIf="isGeneralSettingsEnabled" class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
                            <a class="menu-link" routerLink="/settings/general" [routerLinkActive]="['active']">
                                <span class="menu-text">{{ 'SETTING_PAGE.HEADER.MANU_LINKS.GENERAL' | transloco }}</span>
                                <ng-container *ngIf="rootArrowEnabled">
                                    <i class="menu-arrow"></i>
                                </ng-container>
                            </a>
                        </li>
                    </ul>
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>
